export const profile = {
  name: "Sim Hyeon Cheol",
  role: "풀스택 개발자",
  headline: "플랫폼의 경계를 넘어\n서비스 전체를 구현합니다.",
  intro:
    "모바일 앱과 SDK 개발을 주도해 왔으며, 웹 화면부터 백엔드까지 서비스에 필요한 기술을 연결합니다.",
  location: "경기도 고양시",
  email: "app-le@kakao.com",
  phone: "010-7638-0101",
  blog: "https://sime.tistory.com",
  birthYear: "1991년생",
  strength: "현장 중심 시스템 통합 및 운영 안정화",
  career: "10년",
  certification: "정보처리기사\n전산응용기계제도기능사",
  availability: "모바일 · 웹 · 서버를 연결하는 개발자",
  philosophy:
    "웹 프론트엔드부터 API와 데이터베이스, 모바일 앱과 외부 장비 연동까지 서비스 구현에 필요한 여러 영역을 직접 다뤄왔습니다. 특정 플랫폼에 머무르기보다 문제에 맞는 기술을 선택하고, 실제로 운영할 수 있는 형태까지 완성하는 것을 중요하게 생각합니다.",
  links: [
    { label: "이메일", href: "mailto:app-le@kakao.com" },
  ],
} as const;
